import { InfoCircleFilled } from '@ant-design/icons';
import { PaymentElement } from '@stripe/react-stripe-js';
import { Alert, Button, Checkbox, Col, Row, Spin, Tooltip } from 'antd';
import { StyledNewStripePaymentMethodForm } from './NewStripePaymentMethodForm.styled';
import useNewStripePaymentMethodForm from './useNewStripePaymentMethodForm.hook';

export default function NewStripePaymentMethodForm({
  paymentIntentId,
  subscriptionTypeId,
  amount,
  subscriptionParams,
  futurePayments,
  setFuturePayments,
  promotionCode,
  elementsRef,
}) {
  const { state, actions } = useNewStripePaymentMethodForm({
    paymentIntentId,
    subscriptionTypeId,
    amount,
    subscriptionParams,
    setFuturePayments,
    promotionCode,
    elementsRef,
  });

  const handleOnSaveCardClick = (event) => {
    setFuturePayments(event.target.checked);
  };

  return (
    <StyledNewStripePaymentMethodForm>
      <form onSubmit={actions.pay}>
        <Row>
          <Col span={24} className="save-card-check">
            <Checkbox
              checked={futurePayments}
              onChange={handleOnSaveCardClick}
              disabled={subscriptionParams.autoRenew}
            >
              I want to save my card for future payments
              {subscriptionParams.autoRenew ? (
                <Tooltip title="If you don't want to save the card unselect the auto renewal option above">
                  {' '}
                  <InfoCircleFilled className="info" />
                </Tooltip>
              ) : null}
            </Checkbox>
          </Col>
          <Col span={24} className="payment-form">
            <PaymentElement
              onReady={() => {
                actions.setState({ loading: false });
              }}
              onChange={(event) => {
                actions.setPaymentReady(event.complete);
              }}
            />
            {state.loading && (
              <div className="loader">
                <Spin />
              </div>
            )}
          </Col>
        </Row>
        <Row className="mt" justify="end" gutter={12}>
          {state.error && (
            <Col className="mb" span={24}>
              <Alert
                message={state.error}
                type="error"
                closable
                onClose={actions.closeError}
              />
            </Col>
          )}
          <Col>
            <Button
              type="primary"
              htmlType="submit"
              disabled={
                !state.stripe || state.processing || !state.isPaymentReady
              }
              loading={state.processing}
              size="large"
              className="pay-button"
            >
              Pay ${amount}
            </Button>
          </Col>
        </Row>
      </form>
    </StyledNewStripePaymentMethodForm>
  );
}
